var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define('extensions/uv-ebook-extension/Extension',["require", "exports", "../../modules/uv-shared-module/BaseEvents", "../../modules/uv-shared-module/BaseExtension", "../../modules/uv-ebookleftpanel-module/EbookLeftPanel", "./Events", "./DownloadDialogue", "../../modules/uv-ebookcenterpanel-module/EbookCenterPanel", "../../modules/uv-shared-module/FooterPanel", "../../modules/uv-ebookmobilefooterpanel-module/MobileFooter", "../../modules/uv-shared-module/HeaderPanel", "../../modules/uv-dialogues-module/MoreInfoDialogue", "../../modules/uv-moreinforightpanel-module/MoreInfoRightPanel", "./SettingsDialogue", "./ShareDialogue"], function (require, exports, BaseEvents_1, BaseExtension_1, EbookLeftPanel_1, Events_1, DownloadDialogue_1, EbookCenterPanel_1, FooterPanel_1, MobileFooter_1, HeaderPanel_1, MoreInfoDialogue_1, MoreInfoRightPanel_1, SettingsDialogue_1, ShareDialogue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Extension = /** @class */ (function (_super) {
        __extends(Extension, _super);
        function Extension() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Extension.prototype.create = function () {
            var _this = this;
            _super.prototype.create.call(this);
            this.component.subscribe(BaseEvents_1.BaseEvents.CANVAS_INDEX_CHANGED, function (canvasIndex) {
                _this.viewCanvas(canvasIndex);
            });
            this.component.subscribe(Events_1.Events.CFI_FRAGMENT_CHANGED, function (cfi) {
                _this.cfiFragement = cfi;
                _this.fire(Events_1.Events.CFI_FRAGMENT_CHANGED, _this.cfiFragement);
            });
        };
        Extension.prototype.dependencyLoaded = function (_index, _dep) {
        };
        Extension.prototype.createModules = function () {
            _super.prototype.createModules.call(this);
            if (this.isHeaderPanelEnabled()) {
                this.headerPanel = new HeaderPanel_1.HeaderPanel(this.shell.$headerPanel);
            }
            else {
                this.shell.$headerPanel.hide();
            }
            if (this.isLeftPanelEnabled()) {
                this.leftPanel = new EbookLeftPanel_1.EbookLeftPanel(this.shell.$leftPanel);
            }
            else {
                this.shell.$leftPanel.hide();
            }
            this.centerPanel = new EbookCenterPanel_1.EbookCenterPanel(this.shell.$centerPanel);
            if (this.isRightPanelEnabled()) {
                this.rightPanel = new MoreInfoRightPanel_1.MoreInfoRightPanel(this.shell.$rightPanel);
            }
            else {
                this.shell.$rightPanel.hide();
            }
            if (this.isFooterPanelEnabled()) {
                this.footerPanel = new FooterPanel_1.FooterPanel(this.shell.$footerPanel);
                this.mobileFooterPanel = new MobileFooter_1.FooterPanel(this.shell.$mobileFooterPanel);
            }
            else {
                this.shell.$footerPanel.hide();
            }
            this.$moreInfoDialogue = $('<div class="overlay moreInfo" aria-hidden="true"></div>');
            this.shell.$overlays.append(this.$moreInfoDialogue);
            this.moreInfoDialogue = new MoreInfoDialogue_1.MoreInfoDialogue(this.$moreInfoDialogue);
            this.$shareDialogue = $('<div class="overlay share" aria-hidden="true"></div>');
            this.shell.$overlays.append(this.$shareDialogue);
            this.shareDialogue = new ShareDialogue_1.ShareDialogue(this.$shareDialogue);
            this.$downloadDialogue = $('<div class="overlay download" aria-hidden="true"></div>');
            this.shell.$overlays.append(this.$downloadDialogue);
            this.downloadDialogue = new DownloadDialogue_1.DownloadDialogue(this.$downloadDialogue);
            this.$settingsDialogue = $('<div class="overlay settings" aria-hidden="true"></div>');
            this.shell.$overlays.append(this.$settingsDialogue);
            this.settingsDialogue = new SettingsDialogue_1.SettingsDialogue(this.$settingsDialogue);
            if (this.isHeaderPanelEnabled()) {
                this.headerPanel.init();
            }
            if (this.isLeftPanelEnabled()) {
                this.leftPanel.init();
            }
            if (this.isRightPanelEnabled()) {
                this.rightPanel.init();
            }
            if (this.isFooterPanelEnabled()) {
                this.footerPanel.init();
            }
        };
        Extension.prototype.isLeftPanelEnabled = function () {
            return true;
        };
        Extension.prototype.render = function () {
            _super.prototype.render.call(this);
            this.checkForCFIParam();
        };
        Extension.prototype.getEmbedScript = function (template, width, height) {
            var appUri = this.getAppUri();
            var iframeSrc = appUri + "#?manifest=" + this.helper.manifestUri + "&cfi=" + this.cfiFragement;
            var script = Utils.Strings.format(template, iframeSrc, width.toString(), height.toString());
            return script;
        };
        Extension.prototype.checkForCFIParam = function () {
            var cfi = this.data.cfi;
            if (cfi) {
                this.component.publish(Events_1.Events.CFI_FRAGMENT_CHANGED, cfi);
            }
        };
        return Extension;
    }(BaseExtension_1.BaseExtension));
    exports.Extension = Extension;
});
//# sourceMappingURL=Extension.js.map
